module.exports = __webpack_public_path__ + "static/media/3.df2fde61.jpg";